<template>
    <div class="visitor-attribute-container">
        <div class="attribute-card">
            <div class="no-attributes" v-if="!hasAttributes">
                <p>{{ noAttributesMessage }}</p>
            </div>

            <div class="attributes-content" v-else>
                <div class="attribute-row" v-for="(attribute, key) in currentAttributeList" :key="key">
                    <div class="attribute-icon">
                        <span class="material-icons">{{ getAttributeIcon(key, attribute.type) }}</span>
                    </div>
                    <div class="attribute-details">
                        <div class="attribute-name">{{ getAttributeLabel(key) }}</div>
                        <div class="attribute-value" v-tippy="{ content: formatAttributeValue(attribute, key) }">
                            {{ formatAttributeValue(attribute, key) }}
                        </div>
                    </div>
                    <div class="attribute-actions">
                        <button class="action-button edit-btn"
                                v-if="isAttributeEditable(key)"
                                @click="editAttribute(key, attribute)">
                            <span class="material-icons">edit</span>
                        </button>
                        <button class="action-button copy-btn" @click="copyAttribute(key, attribute)">
                            <span class="material-icons">content_copy</span>
                        </button>
                        <button class="action-button delete-btn"
                                v-if="isAttributeDeletable(key)"
                                @click="confirmDeleteAttribute(key)">
                            <span class="material-icons">delete</span>
                        </button>
                    </div>
                </div>
                <div class="meta-referrals-section"
                     v-if="metaReferralsBtn && visitor && visitor.metaReferrals && visitor.metaReferrals.length > 0">
                    <div class="meta-referrals-button" @click="modaladvertisingdetail = true">
                        <span class="material-icons">ads_click</span>
                        <span>İlgili Reklamlar</span>
                        <span class="material-icons">arrow_forward</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="editModal" class="va-modal-overlay">
            <div class="va-modal">
                <div class="va-modal-header">
                    <div class="va-modal-title">{{ editModalTitle }}</div>
                    <button class="va-modal-close" @click="closeEditModal"><span class="material-icons">close</span></button>
                </div>
                <div class="va-modal-body">
                    <div class="edit-attribute-form">
                        <template v-if="editingAttribute.type === 'boolean'">
                            <a-switch v-model="editingAttributeValue" />
                        </template>
                        <template v-else-if="editingAttribute.type === 'date'">
                            <a-date-picker
                                v-model="editingAttributeValue"
                                :style="{ width: '100%' }"
                                :format="dateFormat"
                                :placeholder="$t('message.selectDate')"
                                :show-today="true"
                                :allow-clear="true"
                                @change="handleDateChange"
                            />
                        </template>
                        <template v-else-if="editingAttribute.type === 'dropdown'">
                            <a-select
                                v-model="editingAttributeValue"
                                :style="{ width: '100%' }"
                                :placeholder="$t('message.selectOption')"
                                :allow-clear="true"
                            >
                                <a-select-option
                                    v-for="option in editingAttribute.options"
                                    :key="option"
                                    :value="option"
                                >
                                    {{ formatDropdownOption(option, editingAttributeKey) }}
                                </a-select-option>
                            </a-select>
                        </template>
                        <template v-else-if="editingAttribute.type === 'json'">
                            <prism-editor v-model="editingAttributeValue" class="json-editor" :highlight="highlighter" />
                        </template>
                        <template v-else>
                            <input
                                v-model="editingAttributeValue"
                                :type="editingAttribute.type === 'number' ? 'number' : 'text'"
                                class="edit-input"
                                :placeholder="$t('message.enterNewValue')"
                            />
                        </template>

                        <div class="form-actions">
                            <button class="cancel-btn" @click="closeEditModal">{{ $t("message.cancel") }}</button>
                            <button class="save-btn" @click="saveAttributeEdit">{{ $t("message.update") }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="addModal" class="va-modal-overlay">
            <div class="va-modal">
                <div class="va-modal-header">
                    <div class="va-modal-title">{{ $t('settings.newVisitorProfileInformation') }}</div>
                    <button class="va-modal-close" @click="addModal = false"><span class="material-icons">close</span></button>
                </div>
                <div class="va-modal-description">{{ $t('settings.newVisitorProfileInformationDescription') }}</div>
                <div class="va-modal-body">
                    <VisitorAttributesForm @input="(data) => (form = data)" />
                </div>
                <div class="va-modal-footer">
                    <button class="cancel-btn" @click="addModal = false">{{ $t('message.cancel') }}</button>
                    <button class="save-btn" @click="createVisitorAttribute()">{{ $t('settings.create') }}</button>
                </div>
            </div>
        </div>

        <div v-if="deleteModal" class="va-modal-overlay">
            <div class="va-modal">
                <div class="va-modal-header">
                    <div class="va-modal-title">Silme Onayı</div>
                    <button class="va-modal-close" @click="closeDeleteModal"><span class="material-icons">close</span></button>
                </div>
                <div class="va-modal-body">
                    <div class="delete-confirm">
                        <p><b>{{ getAttributeLabel(deleteAttributeKey) }}</b> alanını silmek istediğinizden emin misiniz?</p>
                        <div class="form-actions">
                            <button class="cancel-btn" @click="closeDeleteModal">{{ $t("message.cancel") }}</button>
                            <button class="delete-confirm-btn" @click="deleteAttribute">{{ $t("message.delete") }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a-tooltip placement="topLeft" v-if="canAddAttribute">
            <template slot="title">
                <span>Yeni Öznitelik Ekle</span>
            </template>
            <button class="add-attribute-button" @click="openAddModal">
                <span class="material-icons">add</span>
            </button>
        </a-tooltip>

        <VisitorMetaReferralsModal
            v-if="modaladvertisingdetail"
            :metaReferrals="visitor.metaReferrals"
            :modaladvertisingdetail="modaladvertisingdetail"
            @close="modaladvertisingdetail = false"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import { PrismEditor } from "vue-prism-editor";
import "prismjs/themes/prism.css";
import "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import { copyText2Clipboard, maskContactInfo, SanitizeHtml } from "../../../utils/utils";
import _ from "lodash";
import VisitorAttributesForm from "../Settings/components/VisitorAttributesForm.vue";
import VisitorMetaReferralsModal from "../../../components/visitor/VisitorMetaReferralsModal.vue";

const log = log2("VisitorAttributes");
export default {
    name: "VisitorAttributes",
    props: {
        metaReferralsBtn: {
            type: Boolean,
            default: false,
        },
        visitor: {
            type: Object,
            required: true
        },
        showOnlyGeneral: {
            type: Boolean,
            default: false
        },
        showOnlyProfile: {
            type: Boolean,
            default: false
        },
        isReadOnly: {
            type: Boolean,
            default: false
        }
    },
    components: {
        VisitorAttributesForm,
        PrismEditor,
        VisitorMetaReferralsModal,
    },
    data() {
        return {
            form: {},
            dateFormat: "YYYY-MM-DD",
            // Defines icon and editability for known Visitor model fields
            generalInfoConfig: {
                _id: { icon: 'badge', editable: false, type: 'string' },
                fullname: { icon: 'person', editable: true, type: 'string' },
                email: { icon: 'alternate_email', editable: true, type: 'string' },
                phone: { icon: 'phone', editable: true, type: 'string' },
                whatsappId: { icon: 'badge', editable: false, type: 'string' },
                browser: { icon: 'public', editable: false, type: 'string' },
                city: { icon: 'location_city', editable: true, type: 'string' },
                connectionTime: { icon: 'date_range', editable: false, type: 'date' },
                country: { icon: 'public', editable: true, type: 'string' },
                createdAt: { icon: 'date_range', editable: false, type: 'date' },
                instagramUserId: { icon: 'camera_alt', editable: false, type: 'string' },
                messengerUserId: { icon: 'message', editable: false, type: 'string' },
                ipAddress: { icon: 'computer', editable: false, type: 'string' },
                os: { icon: 'settings_suggest', editable: false, type: 'string' },
                platform: { icon: 'devices', editable: false, type: 'string' },
                preferredLang: {
                    icon: 'translate',
                    editable: true,
                    type: 'dropdown',
                    options: ['tr', 'en', 'de', 'fr', 'es', 'it', 'ar', 'ru']
                },
                siteId: { icon: 'web', editable: false, type: 'string' },
                // status: {
                //     icon: 'info',
                //     editable: true,
                //     type: 'dropdown',
                //     options: ['active', 'inactive', 'blocked', 'pending']
                // },
                telegramUserId: { icon: 'send', editable: false, type: 'string' },
                updatedAt: { icon: 'update', editable: false, type: 'date' },
                visitingPage: { icon: 'link', editable: false, type: 'string' },
                whatsappNumber: { icon: 'phone', editable: false, type: 'string' },
                linkedinUserId: { icon: 'work', editable: false, type: 'string' },
                blockBy: { icon: 'block', editable: false, type: 'string' },
                isBlocked: { icon: 'block', editable: false, type: 'boolean' },
                vipCustomer: { icon: 'star', editable: true, type: 'boolean' },
                owner: { icon: 'person_pin', editable: true, type: 'string' },
            },
            // These keys from visitor object are considered general info
            generalInfoKeys: [
                '_id', 'fullname', 'email', 'phone', 'browser', 'city', 'connectionTime', 'country', 'createdAt',
                'instagramUserId', 'messengerUserId', 'ipAddress', 'os', 'platform', 'preferredLang',
                'siteId', 'telegramUserId', 'updatedAt', 'visitingPage', 'whatsappNumber', 'whatsappId',
                'linkedinUserId', 'blockBy', 'isBlocked', 'vipCustomer', 'owner'
            ],
            isEdit: false,
            editModal: false,
            addModal: false,
            deleteModal: false,
            modaladvertisingdetail: false,
            editingAttributeKey: "",
            editingAttributeValue: "",
            editingAttribute: { type: "string" },
            newAttributeKey: "",
            newAttributeValue: "",
            newAttributeType: "string",
            deleteAttributeKey: "",
            attributeTypes: [
                {value: "string", text: "String"},
                {value: "number", text: "Number"},
                {value: "date", text: "Date"},
                {value: "boolean", text: "Boolean"},
                {value: "json", text: "JSON"}
            ],
            editTimeout: null,
        };
    },
    computed: {
        ...mapState({
            allContactProperties: (state) => state.contactProperty.data || [],
            maskSensitiveInfo: (state) => state.setting.settings.maskSensitiveInfo,
            isRoot: (state) => _.get(state, "auth.user.role.isRoot", false),
        }),

        headerIcon() {
            return this.showOnlyProfile ? 'person_outline' : 'info';
        },

        headerTitle() {
            return this.showOnlyProfile ? 'Profil Alanları' : 'Genel Bilgiler';
        },

        canAddAttribute() {
            // Only allow adding attributes when showing Profile Fields (custom attributes)
            return this.showOnlyProfile && !this.isReadOnly;
        },

        generalInfoList() {
            const info = {};
            this.generalInfoKeys.forEach(key => {
                if (key === 'email' || key === 'phone' || key === 'fullname') {
                    info[key] = {
                        value: this.visitor ? this.visitor[key] : null,
                        type: this.generalInfoConfig[key].type,
                        editable: this.generalInfoConfig[key].editable !== false,
                        icon: this.generalInfoConfig[key].icon || 'label'
                    };
                }
                else if (this.visitor && _.has(this.visitor, key) && this.visitor[key] !== null && this.visitor[key] !== undefined && this.visitor[key] !== '') {
                    const config = this.generalInfoConfig[key] || { type: 'string' };
                    info[key] = {
                        value: this.visitor[key],
                        type: config.type,
                        editable: config.editable !== false,
                        icon: config.icon || 'label'
                    };
                }
            });

            const priorityOrder = ['_id', 'fullname', 'email', 'phone', 'platform','whatsappNumber', 'whatsappId'];

            const priorityKeys = Object.keys(info).filter(key => priorityOrder.includes(key));
            const otherKeys = Object.keys(info).filter(key => !priorityOrder.includes(key)).sort();

            priorityKeys.sort((a, b) => priorityOrder.indexOf(a) - priorityOrder.indexOf(b));

            const sortedKeys = [...priorityKeys, ...otherKeys];

            return sortedKeys.reduce((sortedInfo, key) => {
                sortedInfo[key] = info[key];
                return sortedInfo;
            }, {});
        },

        profileFieldsList() {
            // Now generates list based on all defined Contact Properties
            const fields = {};
            const visitorPropertiesMap = (this.visitor?.contactProperties || []).reduce((map, cp) => {
                // Handle cases where cp.property might be an object or just an ID string
                const propId = (typeof cp.property === 'object' && cp.property !== null) ? cp.property._id : cp.property;
                if (propId) {
                    map[propId] = cp.value;
                }
                return map;
            }, {});

            this.allContactProperties.forEach(propDef => {
                fields[propDef._id] = {
                    value: visitorPropertiesMap[propDef._id] !== undefined ? visitorPropertiesMap[propDef._id] : null,
                    type: propDef.type || 'string', // Use defined type, fallback to string
                    label: propDef.label || propDef.name, // Use defined label
                    editable: true, // All defined properties are editable for the visitor
                    icon: this.getPropertyIcon(propDef.type) // Get icon based on type
                };
            });

            // Profil alanlarını label'a göre sırala
            const fieldKeys = Object.keys(fields);
            const sortedFields = {};

            // Label'lara göre sırala
            fieldKeys.sort((a, b) => {
                const labelA = fields[a].label.toLowerCase();
                const labelB = fields[b].label.toLowerCase();
                if (labelA < labelB) return -1;
                if (labelA > labelB) return 1;
                return 0;
            });

            // Sıralanmış nesneleri yeni objeye ekle
            fieldKeys.forEach(key => {
                sortedFields[key] = fields[key];
            });

            return sortedFields;
        },

        currentAttributeList() {
            if (this.showOnlyGeneral) {
                return this.generalInfoList;
            } else if (this.showOnlyProfile) {
                return this.profileFieldsList;
            }
            // Fallback: Combine if needed (shouldn't be necessary with current usage)
            const combined = { ...this.generalInfoList, ...this.profileFieldsList };

            // Öncelikli sıralama için
            const priorityOrder = ['_id', 'fullname', 'email', 'phone', 'platform','whatsappNumber', 'whatsappId'];

            // Öncelikli alanları ve diğerlerini ayırmak için
            const allKeys = Object.keys(combined);
            const priorityKeys = allKeys.filter(key => priorityOrder.includes(key));
            const otherKeys = allKeys.filter(key => !priorityOrder.includes(key)).sort();

            // Öncelikli alanları belirlenen sırada sırala
            priorityKeys.sort((a, b) => priorityOrder.indexOf(a) - priorityOrder.indexOf(b));

            // Önce öncelikli alanlar, sonra alfabetik sıralı diğer alanlar
            const sortedKeys = [...priorityKeys, ...otherKeys];

            // Yeni sıralamaya göre yeni nesne oluştur
            return sortedKeys.reduce((sortedCombined, key) => {
                sortedCombined[key] = combined[key];
                return sortedCombined;
            }, {});
        },

        hasAttributes() {
            return this.currentAttributeList && Object.keys(this.currentAttributeList).length > 0;
        },

        noAttributesMessage() {
             // Adjust message for profile fields if no properties are defined in the system
            if (this.showOnlyProfile && this.allContactProperties.length === 0) {
                return 'Sistemde tanımlı profil alanı bulunamadı.';
            }
            return this.showOnlyProfile ? 'Profil alanları için değer girilmemiş' : 'Genel bilgi bulunamadı';
        },

        editModalTitle() {
            // Use the stored label for the modal title
            return `${this.editingAttribute.label || 'Alan'} Düzenle`;
        }
    },
    mounted() {
        // Fetch contact property definitions when showing profile fields
        if (this.showOnlyProfile) {
            this.getContactProperties();
        }
    },
    watch: {
        visitor: {
            handler() {
                this.$forceUpdate();
            },
            deep: true,
            immediate: true
        },
        'visitor.contactProperties': {
            handler() {
                this.$forceUpdate();
            },
            deep: true
        }
    },
    methods: {
        ...mapActions({
            getContactProperties: "contactProperty/getContactProperty",
            createContactProperty: "contactProperty/createContactProperty", // Used for creating/updating visitor's value
            deleteContactProperty: "visitor/deleteContactProperty", // Used for deleting visitor's value
            updateVisitorAttr: "visitor/updateVisitorAttr",
            updateContactProperty: "visitor/updateContactProperty",
        }),

        getPropertyIcon(type = 'string') {
             // Centralized icon logic for profile fields
             switch(type) {
                case 'number': return 'pin';
                case 'date': return 'event';
                case 'boolean': return 'toggle_on';
                case 'json': return 'data_object';
                case 'email': return 'alternate_email';
                case 'phone': return 'phone';
                case 'url': return 'link';
                case 'dropdown': return 'arrow_drop_down_circle';
                default: return 'label';
            }
        },

        getAttributeIcon(key, type = 'string') {
            if (this.showOnlyGeneral) {
                return this.generalInfoConfig[key]?.icon || 'label';
            }
            // Use the specific property icon function
            return this.getPropertyIcon(type);
        },

        getAttributeLabel(key) {
            if (this.showOnlyGeneral) {
                return _.startCase(key); // Use _.startCase for general info keys
            }
            // For profile fields, find the definition and use its label
            const propDef = this.allContactProperties.find(p => p._id === key);
            return propDef?.label || _.startCase(key); // Fallback to startCase if definition not found
        },

        isGeneralInfoKey(key) {
            return this.generalInfoKeys.includes(key);
        },

        isShouldMask(value, key) {
            // Find property definition if it's a profile field key
            const propDef = this.showOnlyProfile ? this.allContactProperties.find(p => p._id === key) : null;
            const fieldName = this.showOnlyGeneral ? key : (propDef?.name || key);

            return (
                !this.isRoot &&
                this.maskSensitiveInfo &&
                ['email', 'whatsappNumber', 'phone', 'ipAddress'].includes(fieldName) // Check against field name (like 'email', 'phone')
            );
        },

        isAttributeEditable(key) {
            if (this.isReadOnly) return false;
            if (this.showOnlyGeneral) {
                return this.generalInfoConfig[key]?.editable === true;
            }
            // All profile fields are editable for the visitor's value
            return true;
        },

        isAttributeDeletable(key) {
            // Only allow deleting the *value* for profile fields
            // Check if the visitor actually has a value for this property
            const hasValue = this.currentAttributeList[key]?.value !== null && this.currentAttributeList[key]?.value !== undefined;
            return !this.isReadOnly && this.showOnlyProfile && hasValue;
        },

        formatAttributeValue(attribute, key) {
            if (!attribute || attribute.value === null || attribute.value === undefined) return 'N/A';

            if (attribute.type === 'dropdown') {
                if (key === 'preferredLang') {
                    const languages = {
                        tr: 'Türkçe',
                        en: 'English',
                        de: 'Deutsch',
                        fr: 'Français',
                        es: 'Español',
                        it: 'Italiano',
                        ar: 'العربية',
                        ru: 'Русский'
                    };
                    return languages[attribute.value] || attribute.value;
                }

                if (key === 'status') {
                    const statusMap = {
                        active: this.$t('status.active'),
                        inactive: this.$t('status.inactive'),
                        blocked: this.$t('status.blocked'),
                        pending: this.$t('status.pending')
                    };
                    return statusMap[attribute.value] || attribute.value;
                }

                return attribute.value;
            }

            if (this.isShouldMask(attribute.value, key)) {
                return maskContactInfo(String(attribute.value), 5);
            }

            if (attribute.type === 'date' && attribute.value) {
                try {
                    return new Date(attribute.value).toLocaleDateString() || String(attribute.value);
                } catch (e) {
                    return String(attribute.value || 'N/A');
                }
            } else if (attribute.type === 'boolean') {
                return attribute.value === true || String(attribute.value).toLowerCase() === 'true' ? 'Evet' : 'Hayır';
            } else if (attribute.type === 'json') {
                try {
                    const parsed = typeof attribute.value === 'string' ? JSON.parse(attribute.value) : attribute.value;
                    const stringified = JSON.stringify(parsed, null, 2);
                    return stringified.length > 100 ? stringified.substring(0, 100) + '...' : stringified;
                } catch (e) {
                    const strValue = String(attribute.value || '');
                    return strValue.length > 100 ? strValue.substring(0, 100) + '...' : (strValue || 'N/A');
                }
            }

            return String(attribute.value || 'N/A');
        },

        closeEditModal() {
            this.editModal = false;
            this.editingAttributeKey = "";
            this.editingAttributeValue = "";
            this.editingAttribute = { type: "string" };
        },

        openAddModal() {
            if (!this.canAddAttribute) return;
            this.newAttributeKey = "";
            this.newAttributeValue = "";
            this.newAttributeType = "string";
            this.addModal = true;
        },

        closeAddModal() {
            this.addModal = false;
        },
        createVisitorAttribute() {
            log.info("createVisitorAttribute", { data: this.form });
            this.createContactProperty(this.form).then((res) => {
                this.showModal = false;
                this.$message.success({
                    content: "Yeni Değer Kaydedildi.",
                    duration: 2,
                    key: "saved",
                });
                this.addModal = false;
                this.getContactProperties();
                this.$forceUpdate();
            });
        },

        closeDeleteModal() {
            this.deleteModal = false;
            this.deleteAttributeKey = "";
        },

        editAttribute(key, attribute) {
            if (!this.isAttributeEditable(key)) return;

            this.editingAttributeKey = key;

            // Dropdown için özel işlem
            if (attribute.type === 'dropdown') {
                const config = this.showOnlyGeneral ? this.generalInfoConfig[key] : null;
                const propDef = this.showOnlyProfile ? this.allContactProperties.find(p => p._id === key) : null;

                this.editingAttribute = {
                    type: 'dropdown',
                    label: this.getAttributeLabel(key),
                    options: config?.options || propDef?.options || [],
                    value: this.showOnlyGeneral ? this.visitor[key] : attribute.value
                };
                this.editingAttributeValue = this.showOnlyGeneral ? this.visitor[key] : attribute.value;
            }
            // Tarih için özel işlem
            else if (attribute.type === 'date' && attribute.value) {
                const date = new Date(attribute.value);
                if (!isNaN(date.getTime())) {
                    this.editingAttributeValue = this.$moment(date).format(this.dateFormat);
                } else {
                    this.editingAttributeValue = null;
                }
            } else {
                this.editingAttributeValue = this.showOnlyGeneral ? this.visitor[key] : attribute.value;
            }

            let typeConfig = { type: 'string', label: _.startCase(key) };
            if (this.showOnlyGeneral) {
                typeConfig = this.generalInfoConfig[key] || typeConfig;
                typeConfig.label = _.startCase(key);
            } else {
                const propDef = this.allContactProperties.find(p => p._id === key);
                if (propDef) {
                    typeConfig = {
                        type: propDef.type || 'string',
                        label: propDef.label || propDef.name,
                        options: propDef.options || []
                    };
                }
            }
            this.editingAttribute = typeConfig;
            this.editModal = true;
        },

        saveAttributeEdit() {
            if (this.showOnlyGeneral) {
                this.$set(this.visitor, this.editingAttributeKey, this.editingAttributeValue);

                // Sonra backend'e gönder
                this.updateVisitorAttr({
                    visitorId: this.visitor._id,
                    payload: {
                        [this.editingAttributeKey]: this.editingAttributeValue
                    }
                }).then(() => {
                    this.$message.success(this.$t("message.settingsSaved"));
                    this.$forceUpdate();
                }).catch(err => {
                    console.error(`Error updating visitor field ${this.editingAttributeKey}:`, err);
                    this.$message.error("Genel bilgi güncellenirken bir hata oluştu.");
                });
            } else {
                // Profil alanı için
                // UI'da önce güncelle - contactProperties nesnesinde ilgili değeri bul
                if (!this.visitor.contactProperties) {
                    this.$set(this.visitor, 'contactProperties', []);
                }

                const contactPropertyIndex = (this.visitor.contactProperties || []).findIndex(cp => {
                    return (cp.property && cp.property._id === this.editingAttributeKey) ||
                           (typeof cp.property === 'string' && cp.property === this.editingAttributeKey);
                });

                if (contactPropertyIndex !== -1) {
                    this.$set(this.visitor.contactProperties[contactPropertyIndex], 'value', this.editingAttributeValue);
                } else {
                    const newProperty = {
                        property: this.editingAttributeKey,
                        value: this.editingAttributeValue
                    };
                    this.visitor.contactProperties.push(newProperty);
                    this.$set(this.visitor, 'contactProperties', [...this.visitor.contactProperties]);
                }

                // Sonra backend'e gönder
                this.updateContactProperty({
                    visitor: this.visitor,
                    contactPropertyId: this.editingAttributeKey,
                    updatePayload: {
                        value: this.editingAttributeValue,
                    },
                }).then(() => {
                    this.$message.success(this.$t("message.settingsSaved"));
                    this.$forceUpdate();
                }).catch(err => {
                    console.error(`Error saving profile field ${this.editingAttribute.label}:`, err);
                    this.$message.error("Profil alanı kaydedilirken bir hata oluştu.");
                });
            }
            this.closeEditModal();
        },

        confirmDeleteAttribute(key) {
            if (!this.isAttributeDeletable(key)) return;
            this.deleteAttributeKey = key; // Store property ID
            this.deleteModal = true;
        },

        deleteAttribute() {
            // Call action to delete the visitor's value for this specific property
            if (!this.showOnlyProfile || !this.deleteAttributeKey) return;

            if (this.visitor.contactProperties) {
                const index = this.visitor.contactProperties.findIndex(cp => {
                    return (cp.property && cp.property._id === this.deleteAttributeKey) ||
                           (typeof cp.property === 'string' && cp.property === this.deleteAttributeKey);
                });

                if (index !== -1) {
                    this.visitor.contactProperties.splice(index, 1);
                    this.$set(this.visitor, 'contactProperties', [...this.visitor.contactProperties]);
                }
            }

            this.deleteContactProperty({
                visitorId: this.visitor._id,
                contactPropertyId: this.deleteAttributeKey
            }).then(() => {
                 this.$message.success(this.$t("message.propertyDeleted"));
                 this.$forceUpdate();
            }).catch(err => {
                 console.error(`Error deleting profile field value:`, err);
                 this.$message.error("Profil alanı değeri silinirken bir hata oluştu.");
            });
            this.closeDeleteModal();
        },

        copyAttribute(key, attribute) {
            const value = this.showOnlyGeneral
                ? String(this.visitor[key] || '')
                : String(attribute.value || '');
            copyText2Clipboard(value);
            this.$message.success(this.$t("message.copiedClipboard"));
        },

        highlighter(code) {
            // Ensure Prism is loaded
            if (window.Prism && window.Prism.highlight) {
                 try {
                     // Ensure code is a string
                     const codeStr = String(code || '');
                     return window.Prism.highlight(codeStr, window.Prism.languages.javascript, 'javascript');
                 } catch (e) {
                     console.warn("Prism highlighting failed", e);
                     return SanitizeHtml(String(code || '')); // Fallback to sanitized code
                 }
            }
            return SanitizeHtml(String(code || '')); // Fallback if Prism is not available
        },

        // Hover ve basit değişiklikler için olan changeAttr metodunu da iyileştirelim
        changeAttr(attr, value) {
            if (this.editTimeout) clearTimeout(this.editTimeout);
            if (this.visitor) {
                this.editTimeout = setTimeout(() => {
                    if (this.staticAttributes[attr.name]) {
                        this.updateVisitorAttr({
                            visitorId: this.visitor._id,
                            payload: {
                                [attr.name]: value,
                            },
                        }).then(() => {
                            // Reaktif güncelleme
                            this.$set(this.visitor, attr.name, value);

                            // Üst bileşene bildir
                            this.$emit('attribute-updated', {
                                key: attr.name,
                                value: value
                            });
                        });
                    } else {
                        this.updateContactProperty({
                            visitor: this.visitor,
                            contactPropertyId: attr.id,
                            updatePayload: {
                                value,
                            },
                        }).then((updatedVisitor) => {
                            if (updatedVisitor) {
                                // Visitor nesnesini reactive olarak güncelle
                                Object.keys(updatedVisitor).forEach(key => {
                                    this.$set(this.visitor, key, updatedVisitor[key]);
                                });

                                // Üst bileşene bildir
                                this.$emit('attribute-updated', {
                                    key: attr.id,
                                    value: value,
                                    isProfileField: true
                                });
                            }
                        });
                    }
                    this.$message.success({
                        content: this.$t("message.settingsSaved"),
                        duration: 2,
                        key: "saved",
                    });
                }, 1000);
            }
        },

        handleDateChange(date, dateString) {
            this.editingAttributeValue = dateString;
        },

        formatDropdownOption(option, key) {
            if (key === 'preferredLang') {
                const languages = {
                    tr: 'Türkçe',
                    en: 'English',
                    de: 'Deutsch',
                    fr: 'Français',
                    es: 'Español',
                    it: 'Italiano',
                    ar: 'العربية',
                    ru: 'Русский'
                };
                return languages[option] || option;
            }

            if (key === 'status') {
                return this.$t(`status.${option}`);
            }

            return option;
        },
    }
};
</script>

<style lang="scss" scoped>
.visitor-attribute-container {
    position: relative;
    width: 100%;
    height: 100%;

    .attribute-card {
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        height: 100%;
        display: flex; // Added for flex layout
        flex-direction: column; // Added for flex layout
        position: relative; // Needed for absolute positioning of add button

        .no-attributes {
            padding: 20px;
            text-align: center;
            color: #6b7280;
            font-style: italic;
            flex-grow: 1; // Take remaining space
            display: flex; // Center content vertically
            align-items: center;
            justify-content: center;
        }

        .attributes-content {
            padding: 8px 0;
            overflow-y: auto; // Make content scrollable
            flex-grow: 1; // Take remaining space

            .meta-referrals-section {
                padding: 16px;
                background-color: #f9fafb;
                border-bottom: 1px solid #f3f4f6;
                margin-bottom: 16px;

                .meta-referrals-button {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 8px 16px;
                    border-radius: 6px;
                    background-color: #6366f1;
                    color: white;
                    cursor: pointer;
                    transition: all 0.2s ease-in-out;

                    &:hover {
                        background-color: #4f46e5;
                    }

                    .material-icons {
                        &:first-child {
                            margin-right: 8px;
                        }

                        &:last-child {
                            margin-left: 8px;
                        }
                    }
                }
            }

            .attribute-row {
                display: flex;
                align-items: center;
                padding: 8px 16px;
                border-bottom: 1px solid #f3f4f6;

                &:last-child {
                    border-bottom: none;
                }

                &:hover {
                    background-color: #f9fafb;

                    .attribute-actions {
                        opacity: 1;
                    }
                }

                .attribute-icon {
                    margin-right: 12px;
                    color: #6366f1;
                    width: 24px; // Ensure consistent width
                    text-align: center;

                    .material-icons {
                        font-size: 20px;
                    }
                }

                .attribute-details {
                    flex: 1;
                    overflow: hidden;
                    min-width: 0; // Prevent flex item from overflowing

                    .attribute-name {
                        font-size: 12px;
                        font-weight: 600;
                        color: #6b7280;
                        text-transform: capitalize;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .attribute-value {
                        font-size: 14px;
                        color: #111827;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                .attribute-actions {
                    display: flex;
                    gap: 4px;
                    opacity: 0;
                    transition: opacity 0.2s ease;
                    margin-left: 8px; // Add space between details and actions

                    .action-button {
                        background: none;
                        border: none;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 24px;
                        height: 24px;
                        border-radius: 4px;

                        .material-icons {
                            font-size: 16px;
                        }

                        &.edit-btn {
                            color: #10b981;

                            &:hover {
                                background-color: rgba(16, 185, 129, 0.1);
                            }
                        }

                        &.copy-btn {
                            color: #3b82f6;

                            &:hover {
                                background-color: rgba(59, 130, 246, 0.1);
                            }
                        }

                        &.delete-btn {
                            color: #ef4444;

                            &:hover {
                                background-color: rgba(239, 68, 68, 0.1);
                            }
                        }
                    }
                }
            }
        }
    }

    .add-attribute-button {
        position: absolute;
        bottom: 16px;
        right: 16px;
        width: 40px;
        height: 40px;
        border-radius: 50%; // Make it circular
        background: #6366f1;
        color: white;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); // Slightly stronger shadow
        z-index: 10;
        transition: all 0.2s ease-in-out;

        &:hover {
            background: #4f46e5;
            transform: scale(1.05) translateY(-2px); // Add subtle lift
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
        }

        .material-icons {
            font-size: 22px; // Slightly larger icon
        }
    }
}

// Modal Styles
.va-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 6000;
}

.va-modal {
    background: #ffffff;
    border-radius: 8px;
    min-width: 520px;
    max-width: 90vw;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
}

.va-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #e5e7eb;
}

.va-modal-title {
    font-weight: 600;
    font-size: 16px;
}

.va-modal-description {
    padding: 12px 16px 0 16px;
    color: #6b7280;
    font-size: 13px;
}

.va-modal-close {
    background: transparent;
    border: none;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    cursor: pointer;
}

.va-modal-body {
    padding: 16px;
    overflow: auto;
}

.va-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 16px;
    border-top: 1px solid #e5e7eb;
}

.edit-attribute-form,
.add-attribute-form,
.delete-confirm {
    padding: 16px;

    .form-group {
        margin-bottom: 16px;

        label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;
            color: #374151;
            font-size: 13px; // Slightly smaller label
        }
    }

    .edit-input,
    .edit-select {
        width: 100%;
        padding: 8px 12px;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        font-size: 14px;
        // Removed margin-bottom as it's handled by form-group

        &:focus {
            outline: none;
            border-color: #6366f1;
            box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
        }
    }

    .json-editor {
        min-height: 150px;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        font-family: 'Courier New', monospace;
        font-size: 13px; // Slightly smaller font for code
        padding: 8px;
        box-sizing: border-box;
        margin-bottom: 16px; // Added margin bottom
        // Ensure Prism editor has a background
        background-color: #f9fafb;
        color: #1f2937;
    }

    .form-actions {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        margin-top: 16px; // Add margin top for spacing

        button {
            padding: 8px 16px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;

            &.cancel-btn {
                background-color: white;
                color: #6b7280;
                border: 1px solid #d1d5db;

                &:hover {
                    background-color: #f3f4f6;
                    color: #4b5563;
                }
            }

            &.save-btn {
                background-color: #6366f1;
                color: white;
                border: none;

                &:hover {
                    background-color: #4f46e5;
                }
            }

            &.delete-confirm-btn {
                background-color: #ef4444;
                color: white;
                border: none;

                &:hover {
                    background-color: #dc2626;
                }
            }
        }
    }
}

.delete-confirm p {
    font-size: 14px;
    color: #374151;
    margin-bottom: 16px;
}

// Dark mode support
.dark-mode {
    .visitor-attribute-container {
        .attribute-card {
            background-color: #1f2937;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);

            .no-attributes {
                color: #9ca3af;
            }

            .attributes-content {
                .attribute-row {
                    border-bottom-color: #2d3748;

                    &:hover {
                        background-color: #2d3748;
                    }

                    .attribute-icon {
                        color: #818cf8;
                    }

                    .attribute-details {
                        .attribute-name {
                            color: #9ca3af;
                        }

                        .attribute-value {
                            color: #e5e7eb;
                        }
                    }

                    // Dark mode action button colors if needed
                    .attribute-actions {
                        .action-button {
                            &.edit-btn { color: #34d399; &:hover { background-color: rgba(52, 211, 153, 0.1); } }
                            &.copy-btn { color: #60a5fa; &:hover { background-color: rgba(96, 165, 250, 0.1); } }
                            &.delete-btn { color: #f87171; &:hover { background-color: rgba(248, 113, 113, 0.1); } }
                        }
                    }
                }
            }
        }

        .add-attribute-button {
            background: #6366f1;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4); // Darker shadow

            &:hover {
                background: #4f46e5;
                box-shadow: 0 6px 12px rgba(0, 0, 0, 0.5);
            }
        }
    }

    .edit-attribute-form,
    .add-attribute-form,
    .delete-confirm {
        .form-group {
            label {
                color: #e5e7eb;
            }
        }

        .edit-input,
        .edit-select {
            background-color: #374151; // Use a slightly lighter dark bg for inputs
            border-color: #4b5563;
            color: #e5e7eb;

            &:focus {
                border-color: #818cf8;
                box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.1);
            }
        }

        .json-editor {
            background-color: #1f2937; // Darker bg for editor
            border-color: #4b5563;
            color: #d1d5db;
        }

        .delete-confirm p {
            color: #e5e7eb;
        }

        .form-actions {
            .cancel-btn {
                background-color: #374151;
                border-color: #4b5563;
                color: #e5e7eb;

                &:hover {
                    background-color: #4b5563;
                }
            }
             // Save and delete button colors are likely fine as they use primary/danger colors
        }
    }
}
</style>
<style lang="scss">
.edit-attribute-form{
    .ant-calendar-picker{
        position: relative !important;
    }
}
</style>
